import { render, staticRenderFns } from "./krug.vue?vue&type=template&id=b7c0298a&scoped=true"
import script from "./krug.vue?vue&type=script&lang=js"
export * from "./krug.vue?vue&type=script&lang=js"
import style0 from "./krug.vue?vue&type=style&index=0&id=b7c0298a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c0298a",
  null
  
)

export default component.exports